import React from 'react';
import { Label, Spinner, Wrapper } from './styles';

const LoadingIndicator = ({
  loading = false,
  label,
  ...props
}: {
  loading: boolean;
  label?: React.ReactNode;
}) => {
  if (loading) {
    return (
      <Wrapper {...props}>
        <Spinner />
        <Label>{label}</Label>
      </Wrapper>
    );
  }
  return null;
};

export default LoadingIndicator;
